import { Outlet, Link } from 'react-router-dom'
import { Container, Flex, Button, Text } from '@radix-ui/themes'
import { useAuthentication } from '../contexts/AuthenticationContext.tsx'

export const Layout = () => {
  const { user, logout } = useAuthentication()

  return (
    <Container size="4">
      <Flex direction="column" gap="4">
        <header>
          <Flex justify="between" align="center">
            <h1>ABLunch</h1>
            {user ? (
              <Flex gap="2" align="center">
                <Text size="2">{user.email}</Text>
                <Button size="2" variant="soft" onClick={logout}>
                  로그아웃
                </Button>
              </Flex>
            ) : (
              <Link to="/login">
                <Button size="2" variant="soft">
                  로그인
                </Button>
              </Link>
            )}
          </Flex>
        </header>
        <main>
          <Outlet />
        </main>
      </Flex>
    </Container>
  )
}